export const SCREEN_SMALL_MOBILE = 321
export const SCREEN_MEDIUM_MOBILE = 415
export const SCREEN_MOBILE = 601
export const SCREEN_MD = 769
export const SCREEN_MEDIUM_TABLE = 769
export const SCREEN_TABLE = 991
export const SCREEN_XL = 1201
export const SCREEN_XXL = 1501
